import cx from 'classnames';
import { GIFT } from './constants';
import * as styles from './redemptionTable.module.scss';

type TableTabsProps = {
  selected: string;
  setSelected: (code: string) => void;
};

const TITLE = 'Redeemed Gift Card Credits';

const TableTabs = ({ selected = GIFT, setSelected }: TableTabsProps) => (
  <div className={styles.container}>
    <ul className={cx(styles.row, styles.fffTabs)}>
      <span
        className={cx(styles.tab, { [styles.active]: selected === GIFT })}
        onClick={() => setSelected && setSelected(GIFT)}
        onKeyPress={() => setSelected && setSelected(GIFT)}
        role="button"
        tabIndex={-1}
      >
        {TITLE}
      </span>
    </ul>
  </div>
);

export default TableTabs;
